import ProductImage from '~/components/ProductImage';
import { AdvancedExchangeMethod } from '~/utils/schemas';
import { Product } from './exchangeOptions';

function computeStartingPrice(variants: Product['variants']) {
  const prices = variants.map((v) => v.price);
  const minPrice = Math.min(...prices);
  return minPrice > 0 ? minPrice : 0;
}

export default function ProductDisplay({
  product,
  banner,
  onSelect: onClick,
  currencyFormatter,
  advancedExchangeMethod,
}: {
  product: Product;
  onSelect?: () => void;
  banner?: string | null;
  advancedExchangeMethod: AdvancedExchangeMethod;
  currencyFormatter: (value: number) => string;
}) {
  const startingPrice = computeStartingPrice(product.variants);

  // TODO elevate condition into shared value for showing pricing
  const showStartingPrice =
    advancedExchangeMethod === 'PAYMENT_AND_PARTIAL_REFUND' &&
    startingPrice !== 0;

  return (
    <button
      type="button"
      className="group flex flex-col items-center gap-2 outline-hidden"
      onClick={onClick}
    >
      {/* // TODO re-evaluate the styling of the hover state, to see if it should use the same clarity as the focus state */}
      <div className="relative aspect-square h-full max-h-40 min-h-20 w-full max-w-40 min-w-20 rounded-sm ring-primary ring-offset-2 transition-shadow group-focus-within:ring-2 group-hover:shadow-md">
        <ProductImage
          variant="full"
          alt={product.name}
          src={product.imageUrl}
        />
        {banner && (
          <p className="absolute right-0 bottom-0 left-0 rounded-b bg-black/70 p-1 text-center text-xs break-words text-white">
            {banner}
          </p>
        )}
      </div>
      <p className="text-center text-xs font-medium text-gray-900">
        {product.name}
      </p>
      {showStartingPrice && (
        <p className="text-center text-xs text-gray-500">
          From {currencyFormatter(startingPrice)}
        </p>
      )}
    </button>
  );
}
